import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'

const FtsVersion = (props) => {
  const {ftsVersion} = props;
  const message = "FTS Version: " + ftsVersion;
  const ftsVersionDiv = (
  <div styleName="revision_fts_version" className="revision_fts_version">
  {message} </div>);
  return ftsVersion ? ftsVersionDiv : (null);
}
export default CSSModules(styles)(FtsVersion)

